import React from 'react';
import './DespreNoi.css';

function DespreNoi() {
    return (
        <div className="despre-noi-container">
            <header className="despre-hero">
                <span className="despre-eyebrow">EVOO Medical</span>
                <h1>Despre noi</h1>
                <p className="despre-intro">O clinică gândită de la prima cărămidă pentru un singur lucru: ca medicina să se facă bine, aproape de casă.</p>
            </header>

            <div className="despre-noi-content">

                <div className="despre-noi-section">
                    <div className="section-header">
                        <div className="section-icon">❓</div>
                        <h2>Totul a început cu o întrebare</h2>
                    </div>
                    <p>
                        Înainte de a turna fundația, ne-am întrebat ce ar trebui să aibă o clinică privată ca să fie cu adevărat bună.
                        Nu cât de mare să fie, nici câte servicii să ofere, ci cum ar trebui să se simtă omul care intră pe ușă și cum
                        ar trebui să poată lucra medicul care îl primește.
                    </p>
                    <p>
                        Răspunsul nu a venit dintr-odată. A venit în câțiva ani de proiectare, de construcție și de alegeri grele, la
                        Petrești, la marginea Sebeșului. Acolo a crescut, etaj cu etaj, o clădire care n-a fost niciodată altceva decât
                        ceea ce este: un loc construit numai pentru actul medical. Circuitele, lumina, aerul și drumul pacientului de la
                        recepție până în cabinet au fost desenate înainte de a fi zidite, cu normele sanitare pe masă și cu pacientul în minte.
                    </p>
                </div>

                <div className="despre-noi-section">
                    <div className="section-content-with-image">
                        <div className="section-text">
                            <div className="section-header">
                                <div className="section-icon">🏥</div>
                                <h2>O casă pentru medicină</h2>
                            </div>
                            <p>
                                În iunie 2026, construcția a fost recepționată. Are aproape o mie de metri pătrați utili, șaisprezece
                                cabinete de consultații, o sală de așteptare luminoasă și un oficiu pentru medici. În aceeași clădire,
                                partenerii noștri fac ca o vizită să fie completă: punctul de recoltare pentru analize, farmacia și radiologia.
                            </p>
                        </div>
                        <div className="section-image">
                            <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Clădirea clinicii EVOO Medical" />
                        </div>
                    </div>
                </div>

                <div className="despre-noi-section">
                    <div className="section-header">
                        <div className="section-icon">👥</div>
                        <h2>Oamenii</h2>
                    </div>
                    <p>
                        O clădire nu vindecă pe nimeni. De aceea, partea cea mai importantă a poveștii se scrie acum: oamenii. Căutăm
                        medici care cred, ca și noi, că Sebeșul și satele din jur merită o medicină privată de calitate, fără drumuri
                        lungi până la Alba Iulia, Sibiu sau Cluj. Căutăm asistente care știu că un cuvânt bun la recepție face cât
                        jumătate din tratament. Și îi alegem cu grijă, după reguli scrise, aceleași pentru toți.
                    </p>
                </div>

                <div className="despre-noi-section">
                    <div className="section-header">
                        <div className="section-icon">🌱</div>
                        <h2>Primăvara lui 2027</h2>
                    </div>
                    <p>
                        Deschidem cu opt specialități: medicină internă, cardiologie, diabet și nutriție, reumatologie, hematologie,
                        gastroenterologie, dermatologie și medicina muncii. În toamnă li se alătură încă șapte. Pentru fiecare
                        specialitate vor fi cel puțin doi medici, ca să vă putem primi în fiecare zi, de luni până sâmbătă, de la
                        șapte dimineața până la nouă seara.
                    </p>
                </div>

                <div className="despre-noi-section">
                    <div className="section-header">
                        <div className="section-icon">⭐</div>
                        <h2>Ce ne dorim</h2>
                    </div>
                    <p>
                        Ca peste ani să se spună despre EVOO Medical un lucru simplu: că aici ai fost ascultat, că ți s-a explicat și
                        că ai plecat mai liniștit decât ai venit.
                    </p>
                    <ul className="despre-noi-list">
                        <li>Ascultăm înainte să recomandăm.</li>
                        <li>Explicăm pe înțeles, în scris când e nevoie.</li>
                        <li>Spunem prețul înainte, nu după.</li>
                        <li>Suntem aproape: la Petrești, cu parcare, fără așteptări lungi.</li>
                    </ul>
                    <blockquote className="despre-noi-quote">
                        „Am construit EVOO Medical pentru că am crezut că zona Sebeș merită o clinică privată cu adevărat bună. Acum
                        avem clădirea. Căutăm oamenii care să o facă să trăiască.”
                        <footer>— Nicolae Oltean, Director General</footer>
                    </blockquote>
                </div>

                <p className="despre-noi-footnote">EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026</p>
            </div>
        </div>
    );
}

export default DespreNoi;
